/**
 * ProgressBar Komponente für den Rating-Flow
 */

import React from 'react';

interface ProgressBarProps {
  current: number;
  total: number;
  showLabel?: boolean;
  className?: string;
}

export function ProgressBar({
  current,
  total,
  showLabel = true,
  className = '',
}: ProgressBarProps): React.ReactElement {
  const percentage = Math.round((current / total) * 100);

  return (
    <div className={className}>
      {showLabel && (
        <div className="flex justify-between text-sm text-charcoal-600 mb-2">
          <span className="font-medium">
            Schritt {current} von {total}
          </span>
          <span>{percentage}%</span>
        </div>
      )}
      <div className="h-2 bg-charcoal-100 rounded-full overflow-hidden">
        <div
          className="h-full bg-linear-to-r from-cherry-500 to-cherry-600 transition-all duration-300 ease-out"
          style={{ width: `${percentage}%` }}
          role="progressbar"
          aria-valuenow={current}
          aria-valuemin={0}
          aria-valuemax={total}
        />
      </div>
    </div>
  );
}

// Segmented Progress für Rating-Dimensionen
interface SegmentedProgressProps {
  segments: number;
  completed: number;
  className?: string;
}

export function SegmentedProgress({
  segments,
  completed,
  className = '',
}: SegmentedProgressProps): React.ReactElement {
  return (
    <div className={`flex gap-1.5 ${className}`}>
      {Array.from({ length: segments }).map((_, index) => (
        <div
          key={index}
          className={`h-1.5 flex-1 rounded-full transition-colors duration-300 ${
            index < completed ? 'bg-cherry-500' : 'bg-charcoal-200'
          }`}
        />
      ))}
    </div>
  );
}
